import React, { useState } from "react";
import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { useDispatch, useSelector } from "react-redux";

import { Location } from "../../../@types/location";
import { closeOutline } from "ionicons/icons";
import { selectPartOfFilterOptions } from "../../../store/locations/selectors/selectPartOfFilterOptions";
import { selectPartOfFilterVisible } from "../../../store/locations/selectors/selectPartOfFilterVisible";
import { setPartOfFilter, setPartOfFilterVisible } from "../../../store/locations";
import { selectPartOfFilter } from "../../../store/locations/selectors/selectPartOfFilter";

export const FilterPartOfSelector: React.FC = () => {
  const dispatch = useDispatch();

  const allLocations = useSelector(selectPartOfFilterOptions);
  const partOfFilter = useSelector(selectPartOfFilter);
  const showModal = useSelector(selectPartOfFilterVisible);

  const [partOfFormData, setStatusFormData] = useState<Location[]>([]);
  const initFormData = () => {
    setStatusFormData(
      allLocations.map((partOfItem) => ({
        ...partOfItem,
        checked: !!partOfFilter?.find(({ id }) => id === partOfItem.id),
      }))
    );
  };

  const hangleCheck = (partOfChecked: Location) => {
    setStatusFormData(
      partOfFormData.map((partOfItem) => ({
        ...partOfItem,
        checked: partOfChecked.id === partOfItem.id ? !partOfItem.checked : partOfItem.checked,
      }))
    );
  };

  const applyFilter = async () => {
    dispatch(setPartOfFilter(partOfFormData.filter(({ checked }) => checked)));
    dispatch(setPartOfFilterVisible(false));
  };

  const resetStatusFilter = () => {
    dispatch(setPartOfFilter([]));
    dispatch(setPartOfFilterVisible(false));
  };

  return (
    <>
      <IonModal
        isOpen={showModal}
        onWillPresent={initFormData}
        onDidDismiss={() => dispatch(setPartOfFilterVisible(false))}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filtrar por área de negocio</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => dispatch(setPartOfFilterVisible(false))}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList>
            <IonListHeader>Áreas de negocio</IonListHeader>
            {partOfFormData.map((partOfItem: Location, index: number) => (
              <IonItem key={index}>
                <IonLabel>{partOfItem.name}</IonLabel>
                <IonCheckbox
                  slot="end"
                  checked={partOfItem.checked}
                  onIonChange={() => hangleCheck(partOfItem)}
                />
              </IonItem>
            ))}
          </IonList>
        </IonContent>
        <IonFooter>
          <IonToolbar color="light">
            <IonButtons slot="end">
              <IonButton color="danger" fill="solid" onClick={resetStatusFilter}>
                Limpiar filtro
              </IonButton>
              <IonButton color="primary" fill="solid" onClick={applyFilter}>
                Aplicar filtro
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </>
  );
};
